import { FilterMenuConfig } from '../../types/filter.type';

export const TITLE_FILTERS: FilterMenuConfig = {
  sortMode: 'alphabetic',
  filters: [
    {
      type: 'search',
      value: '',
    },
  ],
};
